// extracted by mini-css-extract-plugin
export default {"drop_down_comp_wrap":"extraDataMenu_drop_down_comp_wrap__ya-Ys","drop_down":"extraDataMenu_drop_down__GsjK0"};